import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { changeShoppingFlag } from '../../store';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

function Terms() {
    let navigate = useNavigate();

    return (
        <div style={{ width: "100%", padding: "0px 20px 65px", background: "#fff", minHeight: "100dvh", height: "100%", position: "relative" }}>
            <div
                style={{
                    color: '#000',
                    cursor: 'pointer',
                    position: 'absolute',
                    right: '15px',
                    top: '20px',
                    display: 'flex',
                    alignItems: 'center',
                }}
                onClick={() => {
                    navigate(-1)
                }}
            >
                <X style={{ width: '28px', height: '28px' }} />
            </div>
            <div style={{ fontSize: "15px", fontWeight: "500", color: "#000", paddingBottom: "30px", textAlign: "left", overflowY: "scroll", height: "100%" }}>
                <h2>이용 약관</h2>

                1.목적<br />
                본 약관은 "서울여의도청년회의소"가 제공하는 T2E 게임 서울여의도청년회의소(이하 "게임")의 이용과 관련하여 회사와 이용자의 권리, 의무 및 책임사항을 규정합니다.<br />
                2.용어의 정의<br />
                "재화": 게임 내에서 획득할 수 있는 가상의 자산 "다이아"<br />
                "프랜차이즈 상품 쿠폰": 회사가 제휴한 프랜차이즈 업체에서 사용 가능한 할인 또는 교환 쿠폰<br />
                "이용자": 본 약관에 동의하고 게임 서비스를 이용하는 자<br />
                3.재화의 전환<br />
                이용자는 게임 내에서 획득한 재화를 회사가 정한 비율에 따라 프랜차이즈 상품 쿠폰으로 전환할 수 있습니다.<br />
                재화의 전환 비율, 쿠폰 종류, 사용 조건 등은 게임 내에서 확인 할 수 있습니다.<br />
                회사는 필요에 따라 재화의 전환 비율 또는 쿠폰 종류를 변경할 수 있습니다.<br />
                4.쿠폰의 사용<br />
                프랜차이즈 상품 쿠폰은 해당 프랜차이즈 업체의 정책에 따라 사용 가능하며, 회사는 쿠폰 사용에 대한 책임을 지지 않습니다.<br />
                쿠폰의 유효기간, 사용 가능 매장 등 상세 내용은 쿠폰에 명시되어 있으며, 이용자는 이를 확인 후 사용해야 합니다.<br />
                쿠폰은 현금으로 환불되지 않으며, 분실 또는 도난 시 재발급되지 않습니다.<br />
                5.서비스의 변경 및 중단<br />
                회사는 게임 서비스 또는 재화-쿠폰 전환 서비스를 변경하거나 중단할 수 있습니다.<br />
                서비스 중단 시, 미사용 쿠폰에 대한 환불 정책은 별도로 공지하지 않습니다.<br />
                6.책임의 제한<br />
                회사는 다음의 경우 책임을 지지 않습니다.<br />
                프랜차이즈 업체의 사정으로 쿠폰 사용이 불가능한 경우<br />
                이용자의 부주의로 쿠폰을 사용하지 못하게 된 경우<br />
                천재지변, 서비스 설비의 장애 등으로 인해 서비스 제공이 불가능한 경우<br />
                7.이용약관의 변경<br />
                회사는 필요에 따라 본 이용약관을 변경할 수 있습니다.<br />
                8.분쟁 해결<br />
                게임 서비스 이용과 관련하여 회사와 이용자 간에 분쟁이 발생한 경우, 상호 협의하여 해결하도록 노력합니다.<br />
                분쟁이 해결되지 않을 경우, 관련 법령에 따라 해결할 수 있습니다.<br />
            </div>
        </div>
    );
}

export default Terms;